export default "__VITE_ASSET__CJVdTmRa__"